import React from 'react';
import { motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { Instagram } from 'lucide-react';
const mediaItems = [{
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/gtqWdqAo8kDAJQ4Lgy8U4j/1780931845122.publer.com.jpg'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/tQ5DkEhxZzsxKmGRUwzMD6/1780931888232.publer.com.jpg'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/1GocBUAvUqnrwJEcmtF6Uk/1780931841123.publer.com.jpg'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/juJMyu5UvRrmdwLEVJDfdm/1780931843118.publer.com.jpg'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/umQubvJzaDTi4J2dS2Ti3y/1780931889214.publer.com.jpg'
}];
export const Gallery = () => {
  const [emblaRef] = useEmblaCarousel({
    loop: true,
    align: 'start'
  }, [Autoplay({
    delay: 3000,
    stopOnInteraction: false,
    stopOnMouseEnter: true
  })]);
  return <section id="galeria" className="py-20 md:py-32 bg-white overflow-hidden" data-id="element-77">
      <div className="max-w-6xl mx-auto px-6 mb-12 text-center" data-id="element-78">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-heading font-bold text-brand-dark mb-4" data-id="element-79">
          By Beauty Lab
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-brand-magenta font-medium" data-id="element-80">
          Resultados que hablan por sí solos
        </motion.p>
      </div>

      <div className="pl-6 md:pl-[calc((100vw-72rem)/2+1.5rem)]" data-id="element-81">
        <div className="embla" ref={emblaRef} data-id="element-82">
          <div className="embla__container flex gap-6" data-id="element-83">
            {mediaItems.map((item, index) => <div key={index} className="embla__slide flex-[0_0_80%] md:flex-[0_0_40%] lg:flex-[0_0_30%] min-w-0 relative group rounded-2xl overflow-hidden aspect-[4/5]" data-id="element-84">
                {item.type === 'video' ? <video src={item.url} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-85" /> : <img src={item.url} alt={`Gallery item ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-86" />}

                <div className="absolute inset-0 bg-gradient-to-t from-brand-magenta/80 via-brand-pink/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8" data-id="element-87">
                  <span className="text-white font-medium flex items-center gap-2 translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-88">
                    <Instagram size={18} data-id="element-89" /> Ver más en Instagram
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <div className="mt-16 flex justify-center" data-id="element-90">
        <a href="#" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-bg text-brand-dark font-medium hover:bg-brand-pink/10 transition-colors border border-brand-pink/20" data-id="element-91">
          <Instagram size={20} className="text-brand-magenta" data-id="element-92" />
          @beautylab_uy
        </a>
      </div>
    </section>;
};